import { render } from "./DatamanagementArea.vue?vue&type=template&id=7dc18866&scoped=true"
import script from "./DatamanagementArea.vue?vue&type=script&lang=js"
export * from "./DatamanagementArea.vue?vue&type=script&lang=js"

import "./DatamanagementArea.vue?vue&type=style&index=0&id=7dc18866&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc18866"]])

export default __exports__